import api from './api'
import { PaginationResponse } from '../types/api'

type ApiSuccessResponse<T> = {
  success?: boolean
  data: T
}

export interface Brand {
  id: string
  name: string
  slug: string
  description?: string
  website?: string
  isActive: boolean
  sortOrder: number
  createdAt: string
  updatedAt: string
}

type ListParams = {
  search?: string
  page?: number
  limit?: number
}

export type BrandListResponse = {
  brands: Brand[]
  pagination: PaginationResponse
}

const brandService = {
  async list(params: ListParams = {}): Promise<BrandListResponse> {
    const { search, page, limit } = params

    const queryParams: Record<string, unknown> = {}

    if (search) queryParams.search = search
    if (page) queryParams.page = page
    if (limit) queryParams.limit = limit

    const response = await api.get<ApiSuccessResponse<BrandListResponse>>(
      '/brands',
      { params: queryParams }
    )

    return response.data.data
  }
}

export default brandService

